import React, { useEffect, useState, useRef } from 'react'
import SecurityCustomPopup from '../SecurityCustomPopup'
import { t } from 'i18next';
import Custom2FA from '../../components/CustomComponents/Custom2FA';
import ModalPopup from '../ModalPopup';
import LineBreaks, { addLineBreaks, displayErrorMessage, retrieveData } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../network/NetworkUtils';
import { GENERATE_UPGRADE_PLUS_OTP, GENERATE_DOWNGRADE_PLUS_OTP, STATUS_SUCCESS_CODE, DOWNGRADE_TO_KDUZU_PLUS, GET_CARDHOLDER_CARDS, FEEDBACK_REASONS, FEEDBACK_SUBMIT } from '../../network/URLConstants';
import { LOGIN_SESSION_KEY } from '../../Redux/reducers';
import { useLocation, useNavigate } from 'react-router';
import Loader from '../../components/CustomComponents/Loader';
import CustomModalPlus from '../helpers/customModalPlus';
import logFirebaseEvents from '../../components/LogFirebaseEvents';
import { getUserMembership, showPrompt } from '../../helpers/utils/Utils';
import Reasonunchecked from '../../assets/kudzu-plus-images/reasonunchecked.png'
import Reasonchecked from '../../assets/kudzu-plus-images/reasonchecked.png'
import CustomTextArea from '../../components/CustomComponents/CustomTextArea';
import ComparisonOffer from '../components/Comparison offer';
import { PAID_PROMO_KEY } from "../../network/URLConstants";
import Cookies from 'js-cookie';


const MembershipSecurityCheck = (props) => {
    const location = useLocation()
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[30px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[#94C3E8] cursor-pointer";
    const HeaderMsgStyles = "sm:w-[425px] font-serif-pro modal-title lg:text-[29px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[38px] font-[300] cursor-pointer text-[#FFFFFF]";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[12px] md:text-[10px] sm:text-[6px] text-[8px] font-normal cursor-pointer";
    const HighlightMsgStylesForPlus = "sm:w-[399px] font-serif-pro text-[#94C3E8] modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer ";
    const HeaderMsgStylesForPlus = "font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer";
    const SubHeaderMsgPlusStyles = "sm:w-[399px] font-hanken-grotesk modal-title mt-[17px] md:text-[16px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-[400] cursor-pointer text-white";
    const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false)
    const [show2faSelection, setshow2faSelection] = useState(false);
    const [selectedOtpType, setSelectedOtpType] = useState('');
    const [selectedType, setSelectedType] = useState(location.state?.type);
    const [twoFactModelTitle, setTwoFactModelTitle] = useState('');
    const [twoFactModelSubTitle, setTwoFactModelSubTitle] = useState('');
    const [showStnadradRatesMessage, setShowStnadradRatesMessage] = useState(false);
    const SelectedCardDetails = useSelector(state => state.selectedCardDetails);
    const [message, setMessage] = useState('');
    const [resendCount, setResendCount] = useState(1);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [isLoading, setIsLoading] = useState(false);
    const sessionKey = useSelector(state => state.loggedSessionKey);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const currentPathFromStoreVal = useSelector(state => state.currentPathFromStore);
    const kudzuFlowFromVal = useSelector(state => state.kudzuFlowFrom);
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [showModel, setShowModel] = useState(false);
    const [modelImage, setModelImage] = useState('')
    const [savingsTheme, setSavingsTheme] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [isSubFooter, setIsSubFooter] = useState(false);
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [carousel, setCarousel] = useState('');
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [btn1TextColor, setBtn1TextColor] = useState("");
    const [cancelPopup, setCancelPopup] = useState("");
    const [borderWhite, setBorderWhite] = useState("");
    const [downgradeSuccess, setDowngradeSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectedOption, setSelectedOption] = useState('');
    const [selectedReasonText, setSelectedReasonText] = useState('');
    const [comments, setComments] = useState('');
    const [isShowTextArea, setIsShowTextArea] = useState(false);
    const [isReasonsResponseData, setIsReasonsResponseData] = useState(false);
    const cardDetails = useSelector(state => state.selectedCardDetails);
    const [errorMessage, setErrorMessage] = useState("");
    const [comparisonClickFrom, setComparisonClickFrom] = useState("");
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
    const userMembershipData = getUserMembership(loggedResponse)
    const [footerText, setFooterText] = useState("");
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        // getFeedback();
        setshow2faSelection(true)
    }, [])


    useEffect(() => {
    }, [message, comments, selectedReasonText])


    const closeOTPVerifyModal = () => { setIsOTPVerifyModalOpen(false) }
    const generate2FAOtp = async (otpType, procType) => {

        var object = {};
        var url = "";

    };


    const handleFeatutes = (fromClick)=>{ 
        setComparisonClickFrom(fromClick)
        showAlertModalPlus(true, '', promoKey == PAID_PROMO_KEY || userMembershipData?.extendTrial ? t('access_exclusive_features_and_benefits_with_kudzu_membership') : t('Access_exclusive_features_and_benefits'), "", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={handlOkComparison} />, true, false);
    }

    const handlOkComparison = () =>{
        setSelectedType(t('upgrade_to_kduzu_plus'))
        setShowPlusModal(false)
        setshow2faSelection(true)
    }

    useEffect(() => {
        // Function to block the back button
        const handleBackButton = (event) => {
            event.preventDefault();

            if (downgradeSuccess) {
                navigate('/home');
            } else {
                if (currentPathFromStoreVal) {
                    navigate(currentPathFromStoreVal)
                }
                else if (kudzuFlowFromVal === t('savings_transfer_money')) {
                    navigate('/AccountServices/Savings');
                }
                else if (kudzuFlowFromVal === t('change_pin_success')) {
                    navigate('/CardServices/CardActionScreen')
                }
                else {
                    navigate('/home')
                }
            }

        };

        window.history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', handleBackButton);
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, [downgradeSuccess, navigate]);

    const generateOtp = async (procType) => {
        debugger
        console.log(selectedOtpType, "generate fun")
        const deviceId = await retrieveData('updatedDeviceId')
        const type = selectedType;

        const otpresendNumber = resendCount;
        if (otpresendNumber >= 4) {
            setMessage(t('exceeded_max_limit'))
            return;
        }
        setIsLoading(true)
        let headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        var requestObj;
        var url;

        switch (type) {
            case t('upgrade_to_kduzu_plus'):
                url = GENERATE_UPGRADE_PLUS_OTP.replace('{cardKey=0}', cards[0]?.CardKey);
                requestObj = {
                    cardKey: cards[0]?.CardKey,
                    IsEmail: procType?.includes('Email') ? true : false
                }
                break;
            case t('downgrad_to_kudzu_plus'):

                url = GENERATE_DOWNGRADE_PLUS_OTP.replace('{cardKey=0}', cards[0]?.CardKey);
                requestObj = {
                    cardKey: cards[0]?.CardKey,
                    IsEmail: procType?.includes('Email') ? true : false
                }
                break;
            default:
                break;
        }

        PostRequest(url, requestObj, headers).then((response) => {
            let parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {

                let sessionIdPayload = { loggedSessionKey: parsedResponse.Response.sessionId }
                dispatch({ type: LOGIN_SESSION_KEY, payload: sessionIdPayload });
                setTimeout(() => {
                    const resendNumber = resendCount + 1;
                    setResendCount(resendNumber);
                    setMessage('')
                    setIsLoading(false)
                    setshow2faSelection(false);
                    setIsOTPVerifyModalOpen(true);
                    setTwoFactModelSubTitle(procType === 'Email' ? t('we_are_sending_you_email_with_verification_code') : t('we_are_sending_you_a_text_with_verification_code'));
                    setShowStnadradRatesMessage(procType === 'Text' ? t('standrd_message_rates_apply') : "");
                    setTwoFactModelTitle(t('great_exclamation'));
                }, 500);
            } else {
                setTimeout(() => {
                    var arrMessages = parsedResponse.Messages;
                    var message = arrMessages[0];
                    var displayText = message.DisplayText;
                    setMessage(displayText);
                    setIsLoading(false)
                    showAlertModalPlus(true, t("alert"), displayText, "", true, false, t('ok'), "", true, require('./../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", '', true, '', false, true, false, true, '2px solid #94C3E8');
                }, 500);

            }
        })

    }

    const verificationSuccess = (type) => {
        if (type == t('upgrade_to_kduzu_plus')) {
            navigate('/kudzuplusterms')
        } else if (type == t('downgrad_to_kudzu_plus')) {
            setShowPlusModal(false)
            setCancelPopup(false)
            showAlertModalPlus(true, t('Continue_with_cancellation'), addLineBreaks(t("You’ll_lose_access_to_your_additional_Kudzu+_features")), t("You’ll_miss_out_on_a_higher_savings_interest"), true, true, t('Continue_with_cancellation_btn'), t('Back_to_Manage_Membership'), true, require('./../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png'), "", true, "#262B3A", '', true, '', false, true, false, true, '2px solid #94C3E8', '#94C3E8', false);
        }
    }
    const verificationFaiure = (type, message) => {
        if (type == t('upgrade_to_kduzu_plus')) {
            setMessage(message)
        }

    }
    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage, borderWhite, btn1TextColor, isDownCancelReason , footerText) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setIsShowTextArea(isDownCancelReason)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)// gradient button for popup
        setLargeImage(largeImage)
        setBorderWhite(borderWhite)//border white for button
        setBtn1TextColor(btn1TextColor)
        setFooterText(footerText)
    }
    const closeModelPlus = () => {
        setShowPlusModal(false)
        const type = selectedType;
        if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('Continue_with_cancellation_btn') && btn2Text == t('Back_to_Manage_Membership')) {
            navigate("/Settings/manageMembershipKudzuplus")
        } else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('done')) {
            navigate("/home")
        } else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('ok')) {
            navigate("/home")
        } else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('Continue_with_cancellation_btn') && btn2Text == t('skip')) {
            showAlertModalPlus(true, '', <><span className='text-[#94C3E8]'>{t("thanks")}</span><span>{addLineBreaks(t("Your_Kudzu_membership_updated"))}</span></>, <>{t("Billing_Cycle_Ends")}<span className='text-[#94C3E8] pl-[5px] cursor-pointer' onClick={() => handleFeatutes(t("Your_Kudzu_membership_updated"))}>{t("Kudzu_features")}</span></>, true, false, t('done'), t('thanks_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false);
        }
        else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('Submit_Feedback') && btn2Text == t('skip')) {
            showAlertModalPlus(true, '', <><span className='text-[#94C3E8]'>{t("thanks")}</span><span>{addLineBreaks(t("Your_Kudzu_membership_updated"))}</span></>, <>{t("Billing_Cycle_Ends")}<span className='text-[#94C3E8] pl-[5px] cursor-pointer' onClick={() => handleFeatutes(t("Your_Kudzu_membership_updated"))}>{t("Kudzu_features")}</span></>, true, false, t('done'), t('thanks_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false);
        }
        else if ( headerMsg === t('access_exclusive_features_and_benefits_with_kudzu_membership') || headerMsg === t('Access_exclusive_features_and_benefits')){
            if(comparisonClickFrom == t("Your_Kudzu_membership_updated")){
                showAlertModalPlus(true, '', <><span className='text-[#94C3E8]'>{t("thanks")}</span><span>{addLineBreaks(t("Your_Kudzu_membership_updated"))}</span></>, <>{t("Billing_Cycle_Ends")}<span className='text-[#94C3E8] pl-[5px] cursor-pointer' onClick={() => handleFeatutes(t("Your_Kudzu_membership_updated"))}>{t("Kudzu_features")}</span></>, true, false, t('done'), t('thanks_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false);
            }
            else{
            showAlertModalPlus(true, '', <><span className='text-[#94C3E8]'>{t("okay")}</span><span>{addLineBreaks(t("You’ve_succesfully_cancelled_your_Kudzu+_membership."))}</span></>, <>{t("Billing_Cycle_Ends")}<span className='text-[#94C3E8] pl-[5px] cursor-pointer'onClick={() => handleFeatutes('')}>{t("Kudzu_features")}</span></>, true, false, t('done'), t('okay_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false);
            }
         }

    }

    const onAcptBtnClickPlusModal = () => {
        debugger;
        const type = selectedType;
        if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('Continue_with_cancellation_btn') && btn2Text == t('Back_to_Manage_Membership')) {
            onDowngradeMemebership();
            setShowPlusModal(false)
        }

        else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('done') && btn2Text == t('okay_btn')) {
            setShowPlusModal(false)
            getFeedback();
        }

        else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('done') && btn2Text == t('thanks_btn')) {
            setShowPlusModal(false)
            navigate("/home");
        }

        else if (btn1Text == t('Continue_with_cancellation_btn') && btn2Text == t('skip')) {
            if (selectedOption == 'other') {
                setShowPlusModal(false) 
                setIsLoading(true)  
                setTimeout(() => {
                    setIsLoading(false) 
                    showAlertModalPlus(true, "", t('Let_us_know_your_reason'), t('Please_provide_your_feedback_below'), true, true, t('Submit_Feedback'), t('skip'), true, "", "", true, "#4B70B940", "", true, "", false, true, false, true, "", "#ffffff", true);
                }, (1000))

            } else if (selectedOption !== '' && selectedReasonText !== '') {
                setShowPlusModal(false)
                feedBackSubmit();
            }
            else {
                return null
            }
        }

        else if (btn1Text == t('Submit_Feedback') && btn2Text == t('skip')) {
            if (comments.length >= 20) {
                setErrorMessage('')
                setShowPlusModal(false)
                feedBackSubmit();
            }
            else {
                setErrorMessage(t('Responses_must_include'))
            }

        }

        else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('ok')) {
            setShowPlusModal(false)
            navigate("/home")
        }

    }

    const getFeedback = async () => {
        setIsLoading(true);
        try {
            setIsLoading(false);
            const deviceId = await retrieveData("updatedDeviceId");
            const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
            const url = FEEDBACK_REASONS;
            const response = await GetRequest(url, headers);
            console.log("Raw API Response:", response);
            const getFeedbackResponse = JSON.parse(response);
            console.log("Parsed Response:", getFeedbackResponse);
            if (getFeedbackResponse.ResponseCode === STATUS_SUCCESS_CODE) {
                const reasonsData = getFeedbackResponse.Response;
                showAlertModalPlus(true, "", t('Let_us_know_your_reason'), t('Please_provide_your_feedback_below'), true, true, t('Continue_with_cancellation_btn'), t('skip'), true, "", () => generateReasonsList(reasonsData), true, "#4B70B940", "", true, "", false, true, false, true, " ", "#ffffff", false);
            } else {
                console.error("API Error: Response code is not success.");
            }
        } catch (error) {
            console.error("Error fetching feedback reasons:", error);
        } finally {
            setTimeout(() => setLoading(false), 500); // Stop loading after delay
        }
    };

    const generateReasonsList = (reasonsData) => {
        return (
            <>
                {reasonsData.map((item) => (
                    <button
                        key={item.ParameterCode}
                        className="w-full mb-3 border-2 border-[#4B70B980] rounded-full 
                text-white text-[12px] items-center lg:h-[60px] md:h-[55px] sm:h-[50px]
                 h-[55px] font-hanken-grotesk font-bold leading-[16px] flex gap-5 p-7 
                 cursor-pointer text-start">

                        <label class="inline-flex items-center cursor-pointer">
                            <input type="radio" name="reason" value={item.ParameterCode} class="sr-only peer"
                                onClick={() => handleSelectOption(item)} />
                            <div class="relative w-[19px] h-[19px] bg-[#324261]  
                      rounded-full peer dark:bg-gray-700  peer-checked:after:border-white
                       after:content-[''] after:start-[2px] after:bg-[#324261]  after:rounded-full
                        after:w-[19px] after:h-[19px] after:transition-all dark:border-gray-600
                         peer-checked:bg-[#2965FB]"></div>
                        </label>

                        <div>{item.DisplayText}</div>
                    </button>
                ))}
            </>
        )
    }

    const feedBackSubmit = async () => {

        const deviceId = await retrieveData('updatedDeviceId')
        setIsLoading(true)
        let headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);

        const requestObj = {
            "cardKey": cardDetails?.CardKey,
            "reason": selectedReasonText,
            "feedback": selectedReasonText == 'Other' ? comments : ""
        }
        const url = FEEDBACK_SUBMIT;
        PostRequest(url, requestObj, headers).then((response) => {
            let parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                setTimeout(() => {
                    showAlertModalPlus(true, '', <><span className='text-[#94C3E8]'>{t("thanks")}</span><span>{addLineBreaks(t("Your_Kudzu_membership_updated"))}</span></>, <>{t("Billing_Cycle_Ends")}<span className='text-[#94C3E8] pl-[5px] cursor-pointer' onClick={ () => handleFeatutes(t("Your_Kudzu_membership_updated"))}>{t("Kudzu_features")}</span></>, true, false, t('done'), t('thanks_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false);
                }, 1000)

            }
        })
    }

    const handleSelectOption = (item) => {
        const selectedReasonOption = item.ParameterCode;
        const selectedReasonText = item.DisplayText
        setSelectedOption(selectedReasonOption);
        setSelectedReasonText(selectedReasonText);
        setErrorMessage('');
    };

   
//   need change after submit here 
    const onCancelBtnClickPlusModal = () => {
        const type = selectedType;
        setShowPlusModal(false)
        if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('Continue_with_cancellation_btn') && btn2Text == t('Back_to_Manage_Membership')) {
            navigate("/Settings/manageMembershipKudzuplus")
        } else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('Continue_with_cancellation_btn') && btn2Text == t('skip')) {
            showAlertModalPlus(true, '', <><span className='text-[#94C3E8]'>{t("thanks")}</span><span>{addLineBreaks(t("Your_Kudzu_membership_updated"))}</span></>, <>{t("After_Sumbission_SubText")}<span className='text-[#94C3E8] pl-[5px] cursor-pointer' onClick={() => handleFeatutes(t("Your_Kudzu_membership_updated"))}>{t("Kudzu_features")}</span><span>.</span></>, true, false, t('done'), t('thanks_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false);
        }
        else if (type == t('downgrad_to_kudzu_plus') && btn1Text == t('Submit_Feedback') && btn2Text == t('skip')) {                                                                                                                                                           
            showAlertModalPlus(true, '', <><span className='text-[#94C3E8]'>{t("thanks")}</span><span>{addLineBreaks(t("Your_Kudzu_membership_updated"))}</span></>, <>{t("Billing_Cycle_Ends")}<span className='text-[#94C3E8] pl-[5px] cursor-pointer' onClick={ () => handleFeatutes(t("Your_Kudzu_membership_updated"))}>{t("Kudzu_features")}</span></>, true, false, t('done'), t('thanks_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false);
        }
    }

    const onDowngradeMemebership = async () => {

        const deviceId = await retrieveData('updatedDeviceId')
        setIsLoading(true)
        let headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const requestObj = {
            sessionId: global.sessionId
        }
        const url = DOWNGRADE_TO_KDUZU_PLUS.replace('{cardKey=0}', cards[0]?.CardKey);

        PostRequest(url, requestObj, headers).then((response) => {
            // debugger;
            let parsedResponse = JSON.parse(response);

            if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {

                setIsLoading(false);
                setDowngradeSuccess(true);
                // const kudzuPlusTrueVal = { kudzuPlusTrue: false };
                // dispatch({ type: 'KUDZU_PLUS_TRUE', payload: kudzuPlusTrueVal });
                const data = parsedResponse?.Response
                console.log("responsed data is", data);
                const ShowUpgradePrompts = showPrompt(data);

                dispatch({ type: "LOGGED_IN_RESPONSE", payload: { loggedInResponse: JSON.stringify(parsedResponse.Response) } });

                dispatch({ type: "SHOW_PROMPT_TRUE", payload: { ShowPromptsTrue: ShowUpgradePrompts }, });

                const hasSubscription = parsedResponse?.Response?.Subscription && Object.keys(parsedResponse?.Response?.Subscription).length > 0
                const isKudzuPlusAccount = {
                    kudzuPlusTrue: hasSubscription == true ? true : false
                };
                dispatch({ type: 'KUDZU_PLUS_TRUE', payload: isKudzuPlusAccount });

                 if(isKudzuPlusAccount.kudzuPlusTrue){
                              const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
                              Cookies.set(kudzuPlusSetForCookies, true, { expires: 1825});
                            }
                 else {
                     const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
                     Cookies.remove(kudzuPlusSetForCookies);
                 }

                  const modalContent = userMembershipData?.membershipType === "Plus"?
                  (
                    <p className='font-[300]'>{t("After_Sumbission_SubText")}<span className='pl-[5px] font-[600] cursor-pointer' onClick={() => handleFeatutes(t("Your_Kudzu_membership_updated"))}>{t("Kudzu_features")}</span></p>
                  ):(
                    <p className='font-[300]'>
                    {t("To_Reactivate_Link")}<span className=' pl-[5px] font-[600] cursor-pointer' onClick={() => navigate('/Settings/ManageMembershipKudzu')}>{t("Manage_Membership_update")}</span>
                    </p>
                  );
                const footerContent = userMembershipData?.membershipType === "Plus"?(
                <>
                
                </>
                ):(
                  <>
                  <span className='text-[#94C3E8] text-[12px]'>{t("Monthly_MemberShip_A4.95")}</span>
                  </>
                );
                setCancelPopup(true)
                callPostLoginAPI();
                setTimeout(() => {
                    showAlertModalPlus(true, '', <><span className='text-[#94C3E8] text-[32px]'>{t("okay")}</span><span className='text-[32px]'>{addLineBreaks(t("You’ve_succesfully_cancelled_your_Kudzu+_membership."))}</span></>, 
                     modalContent
                    , true, false, t('done'), t('okay_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false, 
                    footerContent
                );
                }, 1000)

            } else {
                setTimeout(() => {
                    var arrMessages = parsedResponse.Messages;
                    var message = arrMessages[0];
                    var displayText = message.DisplayText;
                    setMessage(displayText);
                    setIsLoading(false)
                    showAlertModalPlus(true, t("alert"), displayText, "", true, false, t('ok'), "", true, require('./../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", '', true, '', false, true, false, true, '2px solid #94C3E8', false);
                }, 500);

            }
        })
    }

   

    const callPostLoginAPI = async () => {
        setIsLoading(true);
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const response = await GetRequest(GET_CARDHOLDER_CARDS, headers)
        setTimeout(() => {
            setIsLoading(false);
        }, 500);
        var responseObj = JSON.parse(response)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            if (responseObj.Response != undefined && responseObj.Response != null && responseObj.Response.length > 0) {
                const userCardsPayload = { userCards: JSON.stringify(responseObj.Response) };
                dispatch({ type: 'UPDATE_USER_CARDS', payload: userCardsPayload });
            }
        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
        }
    }

    const handleComparisonBackClick = () =>{
        showAlertModalPlus(true, '', <><span className='text-[#94C3E8]'>{t("okay")}</span><span>{addLineBreaks(t("You’ve_succesfully_cancelled_your_Kudzu+_membership."))}</span></>, <>{t("Billing_Cycle_Ends")}<span className='text-[#94C3E8] pl-[5px] cursor-pointer' onClick={() => handleFeatutes('')}>{t("Kudzu_features")}</span></>, true, false, t('done'), t('okay_btn'), true, require('./../../assets/kudzu-plus-images/kudzu-logo-green.png'), "", true, "#2965FB", '', '', '', false, true, false, true, true, '#ffff', false);
    }


    return (
        <div>
            <ModalPopup
                title={<p className={HighlightMsgStyles}> {LineBreaks(twoFactModelTitle)}</p>}
                subtitle={<><p className={HeaderMsgStyles}>{LineBreaks(twoFactModelSubTitle)}</p> {showStnadradRatesMessage && <p className="font-hanken-grotesk my-3 text-[#fff] lg:text-[20px] md:text-[18px] sm:text-[17px] text-[18px] leading-[30px] font-[300]  w-full">{t('standrd_message_rates_apply')}</p>}</>}
                isOpen={isOTPVerifyModalOpen}
                closeIconForPlusModal={true}
                onClose={() => { setIsOTPVerifyModalOpen(false); setshow2faSelection(true); }}
                content={<div className="mt-20"><Custom2FA selected2FAType={selectedOtpType} phoneNumber={""} upgradeInputBg={true} email={""} address={{}} type={selectedType} onClose={closeOTPVerifyModal} verificationFailure={verificationFaiure} verificationSuccess={verificationSuccess} /></div>}
            />
            {/* addLineBreaks( */}

            <SecurityCustomPopup
                title={<p className={HighlightMsgStyles}> {t("Quick_security_check")}</p>} 
                subtitle={<p className={HeaderMsgStyles}>{addLineBreaks(t('New_Device_Security'))}</p>}
                msgContent={<p className="font-hanken-grotesk modal-title md:text-[18px] sm:mt-3 md:mt-2 text-[#FFFFFF] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-light cursor-pointer ">{addLineBreaks(t("Data_Rates_Apply"))}</p>}
                subHeaderMsg={<p className="font-hanken-grotesk modal-title md:text-[18px] sm:mt-3 md:mt-2 text-[#FFFFFF] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-light cursor-pointer ">{addLineBreaks(t("please_select_the_delivery_method"))}</p>}
                isOpen={show2faSelection} onClose={() => {
                    dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
                    setshow2faSelection(false);
                    if (currentPathFromStoreVal) {
                        navigate(currentPathFromStoreVal)
                    }
                    else if (kudzuFlowFromVal === t('savings_transfer_money')) {
                        navigate('/AccountServices/Savings');
                    }
                    else if (kudzuFlowFromVal === t('change_pin_success')) {
                        navigate('/CardServices/CardActionScreen')
                    }
                    else {
                        navigate('/home')
                    }
                }}
                errorMessage={message}
                onClickNext={(object) => {
                    logFirebaseEvents("kudzuplusSecurity", "Next_Clicked", "Next_Clicked", "", "");
                    setSelectedOtpType(object.proc)
                    // generate2FAOtp(t('change_password'), object.proc)
                    generateOtp(object.proc);
                }} />
                
            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                onBack={() => {
                    if (comparisonClickFrom == 'cancelledSuccesfully') {
                        handleComparisonBackClick()
                    } else {
                        closeModelPlus()
                    }

                }}
                image={modelImage}
                carousel={carousel}
                isDownCancelReason={isShowTextArea}
                onchangeTextCancelText={(text) => {
                    if (text.length >= 20) {
                        setErrorMessage('')
                    }
                    setComments(text)
                }}
                summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HighlightMsgStylesForPlus}>{highlightMsg}</p>}
                HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgPlusStyles}>{cancelPopup
                    ? (
                        <>{subHeaderMsg}</>
                    )
                    : subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn1TextColor={btn1TextColor}
                btn2TextColor={'#94C3E8'}
                borderWhite={borderWhite}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
                imageMargin={
                    subHeaderMsg === t("You’ll_miss_out_on_a_higher_savings_interest")
                      ? 'mt-[-35px]'
                      : subHeaderMsg === t("Billing_Cycle_Ends")
                      ? 'mt-[55px]'
                      : ''
                  }
                isDownCancelReasonComments={comments}
                CommnetsValidationError={errorMessage}
                comparisonScreen={comparisonScreen}
                fullWidth={fullWidth}
                footerText={footerText}
            />
            {isLoading && <Loader />}
            {/* {loading && <Loader />} */}
        </div>
    )
}

export default MembershipSecurityCheck
